import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import employerApi from "./api";

const initialState = {
  isLoading: false,
  employers: {},
  suggestedEmployers: [],
};

export const listEmployers = createAsyncThunk("employer/list", async (values, thunk) => {
  try {
    const response = await employerApi.listEmployer(values);
    return response.data;

  } catch (error) {
    return thunk.rejectWithValue(error);
  }
});


export const suggestEmployers = createAsyncThunk("employer/suggest", async (values, thunk) => {
  try {
    const response = await employerApi.suggestionEmployer(values);
    return response.data;

  } catch (error) {
    return thunk.rejectWithValue(error);
  }
});

export const employerSlice = createSlice({
  name: "employer",
  initialState: initialState,

  reducers: {},
  extraReducers: (builder) => {
    builder

      // List Employer
      .addCase(listEmployers.pending, (state) => {
        state.isLoading = true;        
      })
      .addCase(listEmployers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.employers = action.payload;
      })
      .addCase(listEmployers.rejected, (state) => {
        state.isLoading = false;        
      })
      
      // Suggestion Employer
      .addCase(suggestEmployers.pending, (state) => {
        state.isLoading = true;        
      })
      .addCase(suggestEmployers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.suggestedEmployers = action.payload;
      })
      .addCase(suggestEmployers.rejected, (state) => {
        state.isLoading = false;        
      })
  },
});

export const employerState = (state) => {
  return { ...state  };
};
